import _ from "lodash";
import { OrganizationSurveyDto } from "../../server/dto/org/OrganizationSurveyDto";
import { OrganizationPublicId } from "../../server/Types";
import { applyPendingAnswers } from "./surveyMutators";

export const orgSurveyApplyLocalPending = (
  surveyDto: OrganizationSurveyDto,
): OrganizationSurveyDto => {
  surveyDto = _.cloneDeep(surveyDto);
  applyPendingAnswers(surveyDto._local?.answers ?? [], surveyDto);
  return surveyDto;
};

export const emptyOrgSurvey = (
  orgId: OrganizationPublicId,
  surveyName: string,
): OrganizationSurveyDto => ({
  organizationId: orgId,
  surveyName,
  answers: {},
});
